var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function Alert(_a) {
    var title = _a.title, description = _a.description, lists = _a.lists;
    return (_jsxs("div", __assign({ className: "bg-[#EAECF6] rounded-md p-4 border-2 border-[#022A59] gap-2" }, { children: [_jsx("p", __assign({ className: "text-sm font-semibold text-[#262626]" }, { children: title })), description && (_jsx("p", __assign({ className: "text-sm font-medium text-[#262626]" }, { children: description }))), lists && (_jsx("ul", __assign({ className: "pl-4" }, { children: lists === null || lists === void 0 ? void 0 : lists.map(function (list, index) { return (_jsx("li", __assign({ className: "text-sm font-medium text-[#262626] list-disc" }, { children: list }), index)); }) })))] })));
}
